var map = {
	"./Close.png": 1337,
	"./Darvishzadeh.jpg": 6492,
	"./Text.png": 2353,
	"./Time.svg": 5400,
	"./Tree.svg": 7972,
	"./add.png": 8726,
	"./animation_640_kyt1nngd.gif": 9646,
	"./avatar-f.png": 5717,
	"./avatar-m.png": 34,
	"./back.svg": 4347,
	"./calendar.svg": 6762,
	"./chrome.png": 5062,
	"./cl-location.svg": 4718,
	"./clinic-1.jpeg": 2794,
	"./clinic-1.png": 2712,
	"./clinic.jpg": 6596,
	"./dock.png": 5507,
	"./fi_clock.svg": 3487,
	"./file.svg": 9567,
	"./forward.svg": 3122,
	"./home-banner.jpg": 5465,
	"./home.svg": 587,
	"./imagess.png": 396,
	"./koopahi_9c3e00d5d8.webp": 1386,
	"./location.svg": 3968,
	"./m-1.jpg": 8136,
	"./m-2.jpg": 6917,
	"./m-3.jpg": 289,
	"./m-4.jpg": 2969,
	"./m-5.jpg": 1770,
	"./m-5.png": 6439,
	"./menu-btn.svg": 4632,
	"./minus.svg": 33,
	"./plus.svg": 675,
	"./safari.png": 4131,
	"./safari.svg": 4199,
	"./share.png": 7317,
	"./sr-1.svg": 1226,
	"./sr-2.svg": 1298,
	"./sr-3.svg": 4001,
	"./sr-4.svg": 1264,
	"./sr-5.svg": 886,
	"./sr-6.svg": 7947,
	"./wcd.svg": 6170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;